var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("scout-tab-panel", {
    attrs: {
      "is-active": _vm.isActive,
      title: "スカウト済み",
      name: "scout",
      link: _vm.link,
      tooltip: "掲載期間＋１週間、無料で再スカウトを送信することができます。",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }